import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { UilAngleRight } from '@iconscout/react-unicons';
import { privatePage } from '@routers/mainRouter';
import { logo } from '@shared/assets/images';
import { useAltaIntl } from '@shared/hook/useTranslate';

import MenuCustom from './ItemMenu';

const SiderComponent: React.FC<{
  className: string;
  setClassName: (className: string) => void;
}> = props => {
  const { formatMessage } = useAltaIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const { className, setClassName } = props;
  const [width, setWidth] = useState<string | number>();
  const onClick = (e: any) => {
    setClassName('sider-component big');
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (className === 'sider-component') {
      setWidth(0);
    } else {
      setWidth('100%');
    }
  }, [className]);

  return (
    <div className={className} onClick={onClick} onMouseEnter={onClick}>
      <div className="icon">
        <UilAngleRight />
      </div>
      <div className="mask" style={{ width }}>
        {/* <div className="wrap_menu-path"> */}
        <div className="wrap_menu-path">
          <div className="logo">
            <img src={logo} alt="logo" onClick={() => navigate('/')} />
            <div className="logo__title">{formatMessage('common.logo')}</div>
          </div>
          <div className="menu-wrapper">
            <MenuCustom listNav={privatePage} location={location.pathname} />
          </div>
        </div>
        <div className="copyright">&copy; Copyright: 2023 by Alta Software</div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default SiderComponent;
